<template>
  <div class="app-content content ">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h2 class="content-header-title float-start mb-0">
                Download information from {{ memoir.title }}
              </h2>
            </div>
          </div>
        </div>
        <div class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none" />
      </div>
      <div class="content-body content-body--senior-call">
        <div class="row">
          <div class="col-12">
            <div class="row mb-3">
              <div
                v-if="memoir"
                class="col-sm-12"
              >
                <a
                  v-if="memoir.allow_export"
                  class="btn btn-primary"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="`Download memoirs ${memoir.year}`"
                  @click="downloadMemoir()"
                >
                  <a
                    class="btn btn-icon btn-icon rounded-circle btn-flat-secondary loop-loading p-0"
                    :class="{'d-none': !exportingMemoir}"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Loading export..."
                  ><i
                    data-feather="loader"
                  /></a>
                  <span
                    class="loop-loading"
                    :class="{'d-none': exportingMemoir}"
                  >
                    <i
                      data-feather="file"
                      class="me-25"
                    />
                  </span>

                  {{ !exportingMemoir ? `Download memoirs ${memoir.year}` : 'Downloading memoirs...' }}
                </a>
                <!-- <a
                  class="btn btn-primary ms-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Download PDF memoirs highlights"
                  @click="downloadAwardeds()"
                >
                  <a
                    class="btn btn-icon btn-icon rounded-circle btn-flat-secondary loop-loading p-0"
                    :class="{'d-none': !exportingAwardeds}"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Loading export..."
                  ><i
                    data-feather="loader"
                  /></a>
                  <span
                    class="loop-loading"
                    :class="{'d-none': exportingAwardeds}"
                  >
                    <i
                      data-feather="file"
                      class="me-25"
                    />
                  </span>

                  {{ !exportingAwardeds ? 'Download awardeds memoirs ${memoir.year}' : 'Downloading awardeds memoirs ${memoir.year}...' }}
                </a> -->
                <a
                  v-if="memoir.allow_export_highlights"
                  class="btn btn-primary ms-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="`Download highlights ${memoir.year}`"
                  @click="downloadHighlights()"
                >
                  <a
                    class="btn btn-icon btn-icon rounded-circle btn-flat-secondary loop-loading p-0"
                    :class="{'d-none': !exportingHighlights}"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Loading export..."
                  ><i
                    data-feather="loader"
                  /></a>
                  <span
                    class="loop-loading"
                    :class="{'d-none': exportingHighlights}"
                  >
                    <i
                      data-feather="file"
                      class="me-25"
                    />
                  </span>

                  {{ !exportingHighlights ? `Download highlights ${memoir.year}` : `Downloading highlights ${memoir.year}...` }}
                </a>
                <a
                  v-if="memoir.allow_export"
                  class="btn btn-primary ms-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="`Download memoirs ${memoir.year}`"
                  @click="downloadControlMemoir()"
                >
                  <a
                    class="btn btn-icon btn-icon rounded-circle btn-flat-secondary loop-loading p-0"
                    :class="{'d-none': !exportingControlMemoir}"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Loading export..."
                  ><i
                    data-feather="loader"
                  /></a>
                  <span
                    class="loop-loading"
                    :class="{'d-none': exportingControlMemoir}"
                  >
                    <i
                      data-feather="file"
                      class="me-25"
                    />
                  </span>
                  {{ !exportingControlMemoir ? `Download memoirs control ${memoir.year}` : `Downloading memoirs control ${memoir.year}...` }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  components: {},
  data() {
    return {
      exportingAwardeds: false,
      exportingMemoir: false,
      exportingControlMemoir: false,
      exportingHighlights: false,
      exportingSpinOffs: false,
      memoir: {},
    }
  },
  async mounted() {
    const resp = await Vue.prototype.$http.get(`${Vue.prototype.$groupUrl}/memoirs/get-active-export-memoir`)
    this.memoir = resp.data

    setTimeout(() => {
      // eslint-disable-next-line no-undef
      feather.replace({
        width: 14,
        height: 14,
      })
    }, 200)
  },
  methods: {
    async downloadAwardeds() {
      this.exportingAwardeds = true
      await this.$store.dispatch('memoirsProfile/exportAwardedCSV', {
        year: this.memoir.year,
      })
      this.exportingAwardeds = false
    },
    async downloadMemoir() {
      this.exportingMemoir = true
      await this.$store.dispatch('memoirsProfile/exportCSV', {
        year: this.memoir.year,
      })
      this.exportingMemoir = false
    },
    async downloadControlMemoir() {
      this.exportingControlMemoir = true
      await this.$store.dispatch('memoirsProfile/exportControlCSV', {
        year: this.memoir.year,
      })
      this.exportingControlMemoir = false
    },
    async downloadHighlights() {
      this.exportingHighlights = true
      await this.$store.dispatch('memoirsProfile/exportCSV', {
        year: this.memoir.year,
      })
      this.exportingHighlights = false
    },
    async downloadSpinOffs() {
      this.exportingSpinOffs = true
      await this.$store.dispatch('memoirsProfile/exportCSV', {
        year: this.memoir.year,
      })
      this.exportingSpinOffs = false
    },
  },
}
</script>
